/* NFS Poster Rack — Rotating Carousel + Quick Buy + Search (PATCHED: true centering on edges + no arrow skipping) */
(function () {
  const root = document.querySelector("[data-nfs-pr]");
  if (!root) return;

  const viewport = root.querySelector("[data-nfs-pr-viewport]");
  const track    = root.querySelector("[data-nfs-pr-track]");
  const btnPrev  = root.querySelector("[data-nfs-pr-prev]");
  const btnNext  = root.querySelector("[data-nfs-pr-next]");

  const searchInput = root.querySelector("[data-nfs-pr-search]");
  const searchClear = root.querySelector("[data-nfs-pr-clear]");
  const searchMeta  = root.querySelector("[data-nfs-pr-searchmeta]");

  /* ---------------- iOS caret offset fix (focus mode) ---------------- */
  if (searchInput) {
    const rootEl = document.documentElement;

    const enableFocusMode = () => {
      rootEl.classList.add("nfs-pr--searchFocus");

      const fixCaret = () => {
        try {
          const v = searchInput.value || "";
          searchInput.setSelectionRange(v.length, v.length);
        } catch(e) {}
        void searchInput.offsetHeight;
      };

      requestAnimationFrame(fixCaret);
      setTimeout(fixCaret, 0);
      setTimeout(fixCaret, 60);
      setTimeout(fixCaret, 120);
    };

    const disableFocusMode = () => {
      rootEl.classList.remove("nfs-pr--searchFocus");
    };

    searchInput.addEventListener("focus", enableFocusMode, { passive: true });
    searchInput.addEventListener("blur", disableFocusMode, { passive: true });
  }

  if (!viewport || !track) return;

  /* ---------------- Helpers ---------------- */
  function prRoot() {
    const r = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    return r.endsWith("/") ? r : (r + "/");
  }

  const toText = (x) => {
    if (x == null) return "";
    if (typeof x === "string") return x;
    if (typeof x === "number" || typeof x === "boolean") return String(x);
    if (typeof x === "object") {
      if (typeof x.name === "string") return x.name;
      if (typeof x.value === "string") return x.value;
      if (typeof x.label === "string") return x.label;
      try { return JSON.stringify(x); } catch(e) { return String(x); }
    }
    return String(x);
  };

  function norm(s){
    return (s || "")
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  // Safe logger wrapper
  function logSearch(rawTerm, resultsCount) {
    try {
      if (typeof window.NFS_LOG_SEARCH === "function") {
        window.NFS_LOG_SEARCH(rawTerm, resultsCount, { source: "Ready_Made" });
      }
    } catch(e) {}
  }

  /* ---------------- Carousel ---------------- */
  const SPEED_DESKTOP = 110;
  const SPEED_MOBILE  = 80;

  function getSpeed() {
    return window.matchMedia("(max-width: 768px)").matches
      ? SPEED_MOBILE
      : SPEED_DESKTOP;
  }

  const LOOP_MIN_CARDS   = 10;
  const RESUME_DELAY_MS  = 800;
  const SNAP_MS          = 420;

  let rafId = null;
  let lastTs = 0;
  let offset = 0;

  let isPaused = false;
  let userFeatured = false;
  let featuredEl = null;

  const originalHTML = track.innerHTML;
  track.insertAdjacentHTML("beforeend", originalHTML);

  let loopEnabled = true;

  const getAllCards = () => Array.from(track.querySelectorAll("[data-nfs-pr-card]"));

  function getTrackGapPx() {
    // Use CSS gap if available, fallback to 12
    try {
      const g = getComputedStyle(track).gap || getComputedStyle(track).columnGap || "12px";
      const n = parseFloat(g);
      return Number.isFinite(n) ? n : 12;
    } catch(e) { return 12; }
  }

  function clamp(v, lo, hi){
    if (v < lo) return lo;
    if (v > hi) return hi;
    return v;
  }

  function getEdgeGutters() {
    // Virtual space so FIRST/LAST can sit in the middle
    // gutter = (viewportW - cardW)/2
    const cards = getAllCards();
    const vpW = viewport.clientWidth || 1;

    const first = cards[0];
    const last  = cards[cards.length - 1];

    const firstW = first ? (first.getBoundingClientRect().width || first.clientWidth || 0) : 0;
    const lastW  = last  ? (last.getBoundingClientRect().width  || last.clientWidth  || 0) : 0;

    const leftG  = Math.max(0, (vpW - firstW) / 2);
    const rightG = Math.max(0, (vpW - lastW) / 2);

    return { leftG, rightG, vpW };
  }

  function clampOffset() {
      if (loopEnabled) {
    const halfWidth = track.scrollWidth / 2;
    if (halfWidth <= 0) return;

    // ✅ IMPORTANT:
    // If the user clicked/featured something, keep the exact copy they clicked
    // (allow offset into the 2nd duplicated half). Don't modulo-wrap to the start.
    if (userFeatured || featuredEl) {
      const maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
      offset = clamp(offset, 0, maxOffset);
      return;
    }

    // Normal auto-loop behaviour while rotating
    offset = ((offset % halfWidth) + halfWidth) % halfWidth;
    return;
  }

    // ✅ NON-LOOP: allow negative / over-max offsets so ends can center
    const { leftG, rightG } = getEdgeGutters();
    const maxBase = Math.max(0, track.scrollWidth - viewport.clientWidth);

    const minOffset = -leftG;
    const maxOffset = maxBase + rightG;

    offset = clamp(offset, minOffset, maxOffset);
  }

  function applyTransform() {
    clampOffset();
    track.style.transform = `translate3d(${-offset}px,0,0)`;
  }

  function tick(ts) {
    if (!lastTs) lastTs = ts;
    const dt = (ts - lastTs) / 1000;
    lastTs = ts;

    if (!isPaused) {
      offset += getSpeed() * dt;
      applyTransform();
    }
    rafId = requestAnimationFrame(tick);
  }

  function setFeatured(el) {
    const all = getAllCards();
    all.forEach(c => c.classList.remove("is-featured"));
    featuredEl = el;
    if (!el) return;
    el.classList.add("is-featured");
  }

  function centreCard(el) {
  if (!el) return;

  track.style.transition = `transform ${SNAP_MS}ms cubic-bezier(.2,.85,.25,1)`;

  const vpW = viewport.clientWidth || 1;

  // Track-coordinate center
  const cardCenterX = (el.offsetLeft || 0) + (el.offsetWidth || 0) / 2;
  let desired = cardCenterX - (vpW / 2);

  // ✅ Loop seam-safe centering:
  // pick an equivalent desired position (±halfWidth) that's closest to current offset
  if (loopEnabled) {
    const halfWidth = track.scrollWidth / 2;
    if (halfWidth > 0) {
      // bring desired near the current offset so clampOffset won't "teleport"
      let delta = desired - offset;

      // normalize delta into [-halfWidth/2, +halfWidth/2]
      delta = ((delta + halfWidth / 2) % halfWidth + halfWidth) % halfWidth - halfWidth / 2;

      desired = offset + delta;
    }
  }

  offset = desired;
  applyTransform();

  window.setTimeout(() => { track.style.transition = ""; }, SNAP_MS + 40);
}

  function focusCard(el) {
    isPaused = true;
    userFeatured = true;
    setFeatured(el);
    centreCard(el);
  }

  function resumeRotation() {
    userFeatured = false;
    setFeatured(null);
    isPaused = false;
  }

  function currentClosestIndex() {
    const all = getAllCards();
    if (!all.length) return -1;

    const vpCenterX = offset + (viewport.clientWidth || 1) / 2;

    let bestIdx = 0;
    let bestDist = Infinity;

    for (let i = 0; i < all.length; i++) {
      const c = all[i];
      const cx = (c.offsetLeft || 0) + (c.offsetWidth || 0) / 2;
      const d = Math.abs(cx - vpCenterX);
      if (d < bestDist) { bestDist = d; bestIdx = i; }
    }
    return bestIdx;
  }

  function currentClosestNormIndex(uniqueLen){
  const all = getAllCards();
  if (!all.length) return -1;

  const vpCenterX = offset + (viewport.clientWidth || 1) / 2;

  let bestNorm = 0;
  let bestDist = Infinity;

  for (let i = 0; i < uniqueLen; i++){
    const a = all[i];
    const b = all[i + uniqueLen];

    if (a){
      const ax = (a.offsetLeft || 0) + (a.offsetWidth || 0) / 2;
      const da = Math.abs(ax - vpCenterX);
      if (da < bestDist){ bestDist = da; bestNorm = i; }
    }

    if (b){
      const bx = (b.offsetLeft || 0) + (b.offsetWidth || 0) / 2;
      const db = Math.abs(bx - vpCenterX);
      if (db < bestDist){ bestDist = db; bestNorm = i; }
    }
  }

  return bestNorm;
}

  function focusByIndex(step) {
  isPaused = true;
  userFeatured = false;

  const all = getAllCards();
  const len = all.length;
  if (!len) return;

  // Single card edge case
  if (len === 1) {
    setFeatured(all[0]);
    centreCard(all[0]);
    return;
  }

  let target = null;

  if (loopEnabled && len >= 2) {
    // Because you duplicate HTML once, unique count is half
    const uniqueLen = Math.max(1, Math.floor(len / 2));

    // ✅ closest "real" index (prevents seam bounce)
    const curNorm = currentClosestNormIndex(uniqueLen);
    if (curNorm < 0) return;

    // ✅ wrap
    const nextNorm = ((curNorm + step) % uniqueLen + uniqueLen) % uniqueLen;

    // choose the closest duplicate to avoid teleporting
    const a = all[nextNorm];
    const b = all[nextNorm + uniqueLen] || a;

    const vpCenterX = offset + (viewport.clientWidth || 1) / 2;
    const ax = (a.offsetLeft || 0) + (a.offsetWidth || 0) / 2;
    const bx = (b.offsetLeft || 0) + (b.offsetWidth || 0) / 2;

    target = (Math.abs(ax - vpCenterX) <= Math.abs(bx - vpCenterX)) ? a : b;
  } else {
  // ✅ Non-loop mode: step from the featured card (stable, no skipping)
  let idx = -1;

  if (featuredEl) {
    idx = all.indexOf(featuredEl);
  }

  if (idx < 0) {
    idx = currentClosestIndex();
  }

  if (idx < 0) return;

  const nextIdx = ((idx + step) % len + len) % len;
  target = all[nextIdx];
}

  if (!target) return;

  setFeatured(target);
  centreCard(target);

  window.setTimeout(() => {
    if (!userFeatured) {
      window.setTimeout(() => { if (!userFeatured) isPaused = false; }, RESUME_DELAY_MS);
    }
  }, SNAP_MS + 40);
}

  track.addEventListener("click", (e) => {
    if (e.target.closest("[data-nfs-pr-buy]")) return;
    if (e.target.closest(".nfs-pr__actions")) return;
    if (e.target.closest("button")) return;

    const card = e.target.closest("[data-nfs-pr-card]");
    if (!card) return;

    const clickedLink = e.target.closest("a");

    if (clickedLink) {
      if (!(featuredEl && card.getAttribute("data-handle") === featuredEl.getAttribute("data-handle"))) {
        e.preventDefault();
        focusCard(card);
      }
      return;
    }

    e.preventDefault();
    if (featuredEl && card.getAttribute("data-handle") === featuredEl.getAttribute("data-handle")) {
      resumeRotation();
    } else {
      focusCard(card);
    }
  });

  if (btnPrev) btnPrev.addEventListener("click", () => focusByIndex(-1));
  if (btnNext) btnNext.addEventListener("click", () => focusByIndex(1));

  viewport.addEventListener("mouseenter", () => { isPaused = true; });
  viewport.addEventListener("mouseleave", () => { if (!userFeatured) isPaused = false; });

  /* ---------------- Swipe / Drag (mobile) ---------------- */
  (function enableSwipe(){
    let down = false;
    let dragging = false;

    let startX = 0, startY = 0;
    let lastX = 0;
    let lastT = 0;
    let vel = 0;

    const DRAG_THRESHOLD = 6;
    const FRICTION = 0.95;
    const MIN_VEL = 0.02;
    const MAX_VEL = 2.2;

    function onDown(e){
      if (document.documentElement.classList.contains("nfs-pr--qbOpen")) return;

      down = true;
      dragging = false;

      const p = (e.touches && e.touches[0]) ? e.touches[0] : e;
      startX = lastX = p.clientX;
      startY = p.clientY;
      lastT = performance.now();
      vel = 0;

      isPaused = true;
    }

    function onMove(e){
      if (!down) return;

      const p = (e.touches && e.touches[0]) ? e.touches[0] : e;
      const x = p.clientX;
      const y = p.clientY;

      const dxTotal = x - startX;
      const dyTotal = y - startY;

      if (!dragging){
        if (Math.abs(dxTotal) < DRAG_THRESHOLD && Math.abs(dyTotal) < DRAG_THRESHOLD) return;

        if (Math.abs(dxTotal) <= Math.abs(dyTotal)) {
          down = false;
          if (!userFeatured) isPaused = false;
          return;
        }

        dragging = true;
      }

      e.preventDefault();

      const now = performance.now();
      const dt = Math.max(1, now - lastT);
      const dx = x - lastX;

      vel = dx / dt;
      if (vel >  MAX_VEL) vel =  MAX_VEL;
      if (vel < -MAX_VEL) vel = -MAX_VEL;

      offset -= dx;
      applyTransform();

      lastX = x;
      lastT = now;
    }

    function glide(){
      if (Math.abs(vel) < MIN_VEL) {
        if (!userFeatured) {
          setTimeout(() => { if (!userFeatured) isPaused = false; }, RESUME_DELAY_MS);
        }
        return;
      }

      offset -= vel * 16;
      applyTransform();

      vel *= FRICTION;
      requestAnimationFrame(glide);
    }

    function onUp(){
      if (!down) return;
      down = false;

      if (!dragging){
        if (!userFeatured) isPaused = false;
        return;
      }

      requestAnimationFrame(glide);
    }

    viewport.addEventListener("touchstart", onDown, { passive: true });
    viewport.addEventListener("touchmove", onMove, { passive: false });
    viewport.addEventListener("touchend", onUp, { passive: true });
    viewport.addEventListener("touchcancel", onUp, { passive: true });
  })();

  applyTransform();
  rafId = requestAnimationFrame(tick);

  /* ---------------- Search (filters cards) ---------------- */
  function applyFilter(rawQuery) {
    const q = norm(rawQuery);

    userFeatured = false;
    featuredEl = null;
    setFeatured(null);

    if (!q) {
  track.innerHTML = originalHTML + originalHTML;
  loopEnabled = true;
  offset = 0;
  applyTransform();

  if (btnPrev) btnPrev.style.display = "";
  if (btnNext) btnNext.style.display = "";

  const uploadHint = document.querySelector(".nfs-upload-hint");
if (uploadHint) {
  uploadHint.classList.remove("nfs-upload-hint--hidden");
}
  if (searchMeta) searchMeta.textContent = "";
  isPaused = false;

  return { count: null };
}

    const tokens = q.split(" ").filter(Boolean);

    const tmp = document.createElement("div");
    tmp.innerHTML = originalHTML;
    const originals = Array.from(tmp.querySelectorAll("[data-nfs-pr-card]"));

    const matched = originals.filter(card => {
  const raw = card.getAttribute("data-search-text") || "";
  const text = norm(raw);
  const compactText = text.replace(/\s+/g, "");

  if (!text) return false;

  return tokens.every(t => {
    const compactToken = t.replace(/\s+/g, "");
    return text.includes(t) || compactText.includes(compactToken);
  });
});

    if (matched.length === 0) {
      track.innerHTML = "";
      loopEnabled = false;
      offset = 0;
      applyTransform();
      isPaused = true;

       if (btnPrev) btnPrev.style.display = "none";
  if (btnNext) btnNext.style.display = "none";

  const uploadHint = document.querySelector(".nfs-upload-hint");
if (uploadHint) {
  uploadHint.classList.add("nfs-upload-hint--hidden");
}

      if (searchMeta) {
  searchMeta.innerHTML = `
    <div class="nfs-pr__noResults">
      <div class="nfs-pr__noResultsText">
        😔 Sorry! No matches for <strong>“${rawQuery}”</strong>
      </div>

      

      <a href="/products/quick-designer" class="nfs-pr__noResultsBtn">
        Design my own instead →
      </a>

      <div class="nfs-pr__noResultsOr">or</div>

      <a href="/pages/contact-us" class="nfs-pr__noResultsBtn">
        Get us to Design it for you →
      </a>
    </div>
  `;
}

      return { count: 0 };
    }

    const html = matched.map(el => el.outerHTML).join("");
    track.innerHTML = html;

    const uploadHint = document.querySelector(".nfs-upload-hint");
if (uploadHint) {
  uploadHint.classList.remove("nfs-upload-hint--hidden");
}


    if (matched.length >= LOOP_MIN_CARDS) {
      track.insertAdjacentHTML("beforeend", html);
      loopEnabled = true;
    } else {
      // ✅ small result set: non-loop but NOW true-center on edges works
      loopEnabled = false;
    }

    offset = 0;
    applyTransform();
    isPaused = true;

    // Optional: auto-center the first result after search on phone
    if (window.matchMedia("(max-width: 768px)").matches) {
      const cards = getAllCards();
      if (cards[0]) {
        setFeatured(cards[0]);
        centreCard(cards[0]);
      }
    }

    if (searchMeta) {
      const count = matched.length;
      searchMeta.innerHTML =
        count === 1
          ? `✨ We found <span class="nfs-pr__metaCount">1</span> design for you!`
          : `✨ We found <span class="nfs-pr__metaCount">${count}</span> designs for you!`;
    }

    return { count: matched.length };
  }

  // --- Final search logging controller ---
  const LOG_IDLE_MS = 900;
  const LOG_DEDUPE_MS = 15000;
  let idleTimer = null;
  let lastLoggedTerm = "";
  let lastLoggedAt = 0;

  function maybeLog(term, resultsCount) {
    const clean = (term || "").toString().trim();
    if (!clean) return;

    const now = Date.now();
    const key = clean.toLowerCase();

    if (key === lastLoggedTerm && (now - lastLoggedAt) < LOG_DEDUPE_MS) return;

    lastLoggedTerm = key;
    lastLoggedAt = now;
    logSearch(clean, resultsCount);
  }

  if (searchInput) {
    searchInput.addEventListener("input", () => {
      applyFilter(searchInput.value);

      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        const term = searchInput.value;
        const r = applyFilter(term);
        maybeLog(term, r.count === null ? null : r.count);
      }, LOG_IDLE_MS);
    });

    searchInput.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      clearTimeout(idleTimer);
      const term = searchInput.value;
      const r = applyFilter(term);
      maybeLog(term, r.count === null ? null : r.count);
    });

    searchInput.addEventListener("blur", () => {
      clearTimeout(idleTimer);
      const term = searchInput.value;
      if (!term || !term.trim()) return;
      const r = applyFilter(term);
      maybeLog(term, r.count === null ? null : r.count);
    }, { passive: true });
  }

  if (searchClear && searchInput) {
    searchClear.addEventListener("click", () => {
      clearTimeout(idleTimer);
      searchInput.value = "";
      applyFilter("");
      searchInput.focus();
    });
  }

  /* ---------------- Quick Buy ---------------- */
  const qb         = root.querySelector("[data-nfs-pr-qb]");
  const qbTitle    = root.querySelector("[data-nfs-pr-qb-title]");
  const qbPrice    = root.querySelector("[data-nfs-pr-qb-price]");
  const qbOpts     = root.querySelector("[data-nfs-pr-qb-opts]");
  const qbNote     = root.querySelector("[data-nfs-pr-qb-note]");
  const qbCheckout = root.querySelector("[data-nfs-pr-qb-checkout]");
  const qbCloses   = Array.from(root.querySelectorAll("[data-nfs-pr-qb-close]"));
  const qbImg      = root.querySelector("[data-nfs-pr-qb-img]");

  if (!qb || !qbTitle || !qbPrice || !qbOpts || !qbCheckout) return;

  let qbProduct = null;
  let qbVariant = null;

  function moneyFromCents(cents) {
    const c = Number(cents) || 0;

    let formatted = `$${(c / 100).toFixed(2)}`;
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt = window.Shopify.money_format || "${{amount}}";
      formatted = Shopify.formatMoney(c, fmt);
    }

    const code =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      "";

    return code ? `${formatted} ${code}` : formatted;
  }

  function openQB() {
    qb.hidden = false;
    qb.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("nfs-pr--qbOpen");
  }

  function closeQB() {
    qb.hidden = true;
    qb.setAttribute("aria-hidden", "true");
    qbProduct = null;
    qbVariant = null;
    qbOpts.innerHTML = "";
    if (qbNote) qbNote.textContent = "";
    qbTitle.textContent = "";
    qbPrice.textContent = "";
    if (qbImg) {
  qbImg.src = "";
  qbImg.alt = "";
}
    document.documentElement.classList.remove("nfs-pr--qbOpen");
  }

  qbCloses.forEach(el => el.addEventListener("click", closeQB));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !qb.hidden) closeQB();
  });

  function findVariantBySelectedOptions(product, selected) {
    const sel = (selected || []).map(toText);
    return (product.variants || []).find(v => {
      const opts = Array.isArray(v.options) ? v.options.map(toText) : [];
      for (let i = 0; i < sel.length; i++) {
        if ((opts[i] || "") !== (sel[i] || "")) return false;
      }
      return true;
    }) || null;
  }

  function renderOptions(product) {
    qbOpts.innerHTML = "";
    if (qbNote) qbNote.textContent = "";

    const current = null;
const selected = [];

    (product.options || []).forEach((optName, idx) => {
      const row = document.createElement("div");
      row.className = "nfs-pr-qb__row";

      const label = document.createElement("label");
      label.textContent = toText(optName);

      const select = document.createElement("select");
      select.setAttribute("data-qb-opt", String(idx));

      const setVals = Array.from(new Set(
        (product.variants || [])
          .map(v => (Array.isArray(v.options) ? v.options[idx] : ""))
          .map(toText)
          .filter(Boolean)
      ));

      const placeholder = document.createElement("option");
placeholder.value = "";
placeholder.textContent = "Select one";
placeholder.selected = true;
placeholder.disabled = true;
select.appendChild(placeholder);

setVals.forEach(val => {
  const o = document.createElement("option");
  o.value = val;
  o.textContent = val;

  if (selected[idx] && selected[idx] === val) {
    o.selected = true;
  }

  select.appendChild(o);
});





      select.addEventListener("change", () => {

        const row = select.closest(".nfs-pr-qb__row");

if (row) {
  row.classList.remove("is-error");

  const oldMsg = row.querySelector(".nfs-pr-qb__error");
  if (oldMsg) oldMsg.remove();
}

        const picks = Array.from(qbOpts.querySelectorAll('select[data-qb-opt]'))
          .map(s => toText(s.value));

        const v = findVariantBySelectedOptions(product, picks);
        qbVariant = v;

        if (!v) {
  qbVariant = null;

  if (qbNote) qbNote.textContent = "";
  qbPrice.textContent = "Select options";
  qbCheckout.disabled = false;

  return;
}

        const compareAt = Number(v.compare_at_price || 0);
const price = Number(v.price || 0);

if (compareAt > price) {
  qbPrice.innerHTML = `
    <span class="nfs-pr-qb__compare">${moneyFromCents(compareAt)}</span>
    <span>${moneyFromCents(price)}</span>
  `;
} else {
  qbPrice.textContent = moneyFromCents(price);
}

        if (!v.available) {
          if (qbNote) qbNote.textContent = "This option is sold out.";
          qbCheckout.disabled = true;
        } else {
          if (qbNote) qbNote.textContent = "";
          qbCheckout.disabled = false;
        }
      });

      row.appendChild(label);
      row.appendChild(select);
      qbOpts.appendChild(row);
    });

    qbVariant = null;
qbPrice.textContent = "Select options";
qbCheckout.disabled = false;
qbCheckout.textContent = "Checkout";
  }

  async function loadProduct(handle) {
    const url = `${prRoot()}products/${encodeURIComponent(handle)}.js`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to load product (${res.status})`);
    return await res.json();
  }

  async function addToCart(variantId) {
    const url = `${prRoot()}cart/add.js`;
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error("Add to cart failed.");
    return await res.json();
  }

  root.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-nfs-pr-buy]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute("data-handle");
    if (!handle) return;

    openQB();
    qbTitle.textContent = "Loading…";
    qbPrice.textContent = "";
    qbOpts.innerHTML = "";
    if (qbNote) qbNote.textContent = "";

    try {
  qbProduct = await loadProduct(handle);
  qbTitle.textContent = qbProduct.title || "Quick buy";

  if (qbImg) {
    const imgSrc =
      (qbProduct.featured_image && typeof qbProduct.featured_image === "string")
        ? qbProduct.featured_image
        : "";

    qbImg.src = imgSrc;
    qbImg.alt = qbProduct.title || "Product image";
  }

  renderOptions(qbProduct);

  qbCheckout.disabled = false;

} catch (err) {
      qbTitle.textContent = "Couldn’t load product";
      if (qbNote) qbNote.textContent = "Please try again.";
    }
  });

  qbCheckout.addEventListener("click", async () => {
  const selects = Array.from(qbOpts.querySelectorAll('select[data-qb-opt]'));
  let hasError = false;

  selects.forEach((select) => {
    const row = select.closest(".nfs-pr-qb__row");
    if (!row) return;

    row.classList.remove("is-error");

    const oldMsg = row.querySelector(".nfs-pr-qb__error");
    if (oldMsg) oldMsg.remove();

    if (!select.value) {
      hasError = true;
      row.classList.add("is-error");

      const msg = document.createElement("div");
      msg.className = "nfs-pr-qb__error";
      const label = row.querySelector("label");
const labelText = label ? label.textContent.trim().toLowerCase() : "";

if (labelText.includes("frame size")) {
  msg.textContent = "Please select your Frame Size";
} else if (labelText.includes("power")) {
  msg.textContent = "Please select your Power Option";
} else {
  msg.textContent = "Please select this option first";
}
      row.appendChild(msg);
    }
  });

  if (hasError) return;

  if (!qbVariant || !qbVariant.id) return;

  qbCheckout.textContent = "Checking out...";
qbCheckout.disabled = true;

  try {
    await addToCart(qbVariant.id);
    window.location.href = `${prRoot()}checkout`;
  } catch (e) {
    qbCheckout.disabled = false;
qbCheckout.textContent = "Checkout";
if (qbNote) qbNote.textContent = "Couldn’t add to cart.";
  }
});

})();




